import { render, staticRenderFns } from "./PartnerAccountsMigration.vue?vue&type=template&id=5b511f64&scoped=true"
import script from "./PartnerAccountsMigration.vue?vue&type=script&lang=ts"
export * from "./PartnerAccountsMigration.vue?vue&type=script&lang=ts"
import style0 from "./PartnerAccountsMigration.vue?vue&type=style&index=0&id=5b511f64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b511f64",
  null
  
)

export default component.exports